export default {
  NAME: 'name',
  SOLD: 'sold',
  CODE: 'code',
};
